import axiosInstance from '../config/axios.js';

const API_BASE = '/contract-parties';

const contractPartyService = {
  // Get all contract parties with optional filters and pagination
  getAll: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get contract party by ID
  getById: async (partyId) => {
    const response = await axiosInstance.get(`${API_BASE}/${partyId}`);
    return response.data;
  },

  // Create new contract party
  create: async (partyData) => {
    const response = await axiosInstance.post(API_BASE, partyData);
    return response.data;
  },

  // Update contract party
  update: async (partyId, partyData) => {
    const response = await axiosInstance.put(`${API_BASE}/${partyId}`, partyData);
    return response.data;
  },

  // Delete contract party
  delete: async (partyId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${partyId}`);
    return response.data;
  },

  // Get all contract parties without pagination
  getAllUnpaginated: async (params = {}) => {
    const queryParams = {
      all: 'true',
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  }
};

export default contractPartyService;
